<template>
  <div id='horizontal-align'>
    <div id='container'>
      <div id='image' :style="{ backgroundImage: 'url(' + require('@/assets/images/'+project.image) + ')' }"/>
      <div id='info'>
        <p class='text' id='text-header'>{{project.header}}</p>
        <p class='text' id='sub-header'>{{project.subHeader}}</p>
        <p class='text' id='bread-text'> {{project.text}}</p>
        <button 
          v-for="action in project.actions"
          v-on:click='redirect(action.link)'
          :key="action.link"
        >
          {{action.title}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectPanel',
  props: {
    project: Object
  },
  methods: {
    redirect: (link) => {
      window.open(link)
    }
  }
}
</script>

<style scoped>

button {
  min-width: 100px;
  padding: 0px 10px;
  height: 40px;
  font-size: 1.2rem;
  border: 2px orchid solid;
  background-color: transparent;
  color: white;
  margin: 5px;
  border-radius: 25px;
  text-decoration: none;
  font-family: 'Source Code Pro', monospace;
}

button:hover {
  background-color: orchid;
  color: white;
  cursor: pointer;
}

button:active, button:focus, button:visited {
  outline:none;
}

#horizontal-align {
  /* height: 70vh; */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;
}

#container {
  max-width: 40vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#image {
  background-size: contain;
  flex-shrink: 0;
  width: 300px;
  border-radius: 5%;
  border: 5px white solid;
  height: 300px;
  filter: saturate(0.5);
}

.text {
  color: white;
  margin-top: 30px;
  margin-bottom: 10px;
  font-size: 1.2rem;
}

#bread-text {
  font-family: 'Source Code Pro', monospace;
}

#text-header {
  font-size: 3rem;
}

#sub-header {
  margin-top: 10px;
  color: orchid;
  font-size: 2rem;
}

#info {
  text-align: center;
  padding: 1rem;
}

@media only screen and (max-width: 1000px){
  #container {
    max-width: 100vw;
  }
  #image {
    height: 250px;
    width: 250px;
  }
}

</style>